var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 4",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 76.78 76.9"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m63.35 13.57 23.12 22.88a12 12 0 0 1-4.58 3.76c-3 1.22-9.72.29-9.72.29L60.25 52.18a17.65 17.65 0 0 1 .66 11.75A38.15 38.15 0 0 1 55 75.43l-15.25-14.9L24.5 44.89s4.6-4.39 10.25-5.7a35 35 0 0 1 12.91-.07L59 28.06s-1.5-5.66.64-9.95a14.93 14.93 0 0 1 3.71-4.54Z",
  transform: "translate(-12.31 -10.91)",
  style: {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.31 87.81 2.17-4.57c.41-.72.58-1.68 1.25-2.13l1.68-1.69 6.73-6.74q6.75-6.74 13.59-13.36l3.39 3.44q-6.7 6.76-13.52 13.42l-6.83 6.64-1.71 1.66c-.46.67-1.43.82-2.15 1.22Z",
  transform: "translate(-12.31 -10.91)"
})));
export default SvgPin;